export interface SignalGroup<T> {
  signalType: string;
  label: string;
  signals: T[];
  matchedCount: number;
  totalCount: number;
}

/**
 * Converts a snake_case signal type to Title Case.
 * e.g. 'treating_volume' → 'Treating Volume'
 */
export const formatSignalType = (type: string): string => {
  if (!type) return '';
  return type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

/**
 * Groups signals by signal_type, preserving the order of first appearance.
 * Each group includes a formatted label and match statistics.
 */
export function groupSignalsByType<
  T extends { signal_type: string; matched: boolean },
>(signals: T[]): SignalGroup<T>[] {
  const groupMap = new Map<string, SignalGroup<T>>();

  for (const signal of signals) {
    if (!signal.signal_type) continue;
    const existing = groupMap.get(signal.signal_type);
    if (existing) {
      existing.signals.push(signal);
      existing.totalCount++;
      if (signal.matched) existing.matchedCount++;
    } else {
      groupMap.set(signal.signal_type, {
        signalType: signal.signal_type,
        label: formatSignalType(signal.signal_type),
        signals: [signal],
        matchedCount: signal.matched ? 1 : 0,
        totalCount: 1,
      });
    }
  }

  return Array.from(groupMap.values());
}
